import { IProjectCollateralType } from '~/@api/generated-api-types-project/Api'

const projectCollateralType = {
  [IProjectCollateralType.Property]: 'Nehnuteľnosť',
}

export function getProjectCollateralTypeLabel(key: IProjectCollateralType) {
  return projectCollateralType[key]
}
